import { useEffect, useRef } from "react";
import { useAnalytics } from "@segment/analytics-react";

export function useTrackPage(pageName: string) {
  const { page } = useAnalytics();
  const hasTracked = useRef(false);

  useEffect(() => {
    if (!hasTracked.current) {
      page(undefined, pageName);
      hasTracked.current = true;
    }
  }, [pageName, page]);
}
